import CopilotIcon from 'common/components/icons/Copilot';

export function TeamIcon(fill) {
  return (
    <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.7171 10.3764L10.7169 10.3762C10.5416 10.1595 10.5745 9.84114 10.792 9.66537M10.7171 10.3764L11.4276 10.451C12.0498 9.94744 12.8364 9.66987 13.6422 9.66987C15.5721 9.66987 17.1394 11.2212 17.1394 13.1246V14.2869C17.1394 14.317 17.1128 14.3489 17.0713 14.3489H12.6139C12.335 14.3489 12.1085 14.5753 12.1085 14.8542C12.1085 15.1333 12.335 15.3595 12.6139 15.3595H17.0712C17.6653 15.3595 18.1499 14.8793 18.1499 14.2869V13.1246C18.1499 10.6608 16.1265 8.6592 13.6422 8.6592C12.6059 8.6592 11.5939 9.01648 10.792 9.66537M10.7171 10.3764C10.8929 10.5931 11.2109 10.6266 11.4276 10.4511L10.7171 10.3764ZM10.792 9.66537L10.8863 9.78203M10.792 9.66537C10.792 9.66539 10.792 9.66541 10.7919 9.66543L10.8863 9.78203M10.8863 9.78203C10.7334 9.90557 10.7102 10.1294 10.8336 10.2819L10.8863 9.78203Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.3"
      />
      <path
        d="M10.9367 5.75981C10.9367 7.24012 12.1515 8.44191 13.6422 8.44191C15.1329 8.44191 16.3481 7.24033 16.3481 5.75981C16.3481 4.27931 15.1331 3.07754 13.6422 3.07754C12.1514 3.07754 10.9367 4.27951 10.9367 5.75981ZM11.9473 5.75981C11.9473 4.84003 12.706 4.08821 13.6422 4.08821C14.5786 4.08821 15.3374 4.84006 15.3374 5.75981C15.3374 6.67955 14.5788 7.43124 13.6422 7.43124C12.706 7.43124 11.9473 6.67957 11.9473 5.75981Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.3"
      />
      <path
        d="M2.16195 16.7849H11.8073C12.5299 16.7849 13.1193 16.2014 13.1193 15.4814V13.8467C13.1193 10.4954 10.3662 7.77175 6.98463 7.77175C3.60301 7.77175 0.85 10.4954 0.85 13.8467V15.4814C0.85 16.2014 1.4394 16.7849 2.16195 16.7849ZM1.86067 13.8469C1.86067 11.0562 4.15778 8.78259 6.98463 8.78259C9.81148 8.78259 12.1086 11.0562 12.1084 13.8469V15.4816C12.1084 15.6402 11.9758 15.7744 11.8071 15.7744H2.16195C1.99328 15.7744 1.86067 15.6402 1.86067 15.4816V13.8469Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.3"
      />
      <path
        d="M3.42715 4.253C3.42715 6.1312 4.96903 7.65635 6.86121 7.65635C8.75354 7.65635 10.2954 6.13138 10.2954 4.25317C10.2954 2.37515 8.75372 0.85 6.86121 0.85C4.96887 0.85 3.42715 2.37497 3.42715 4.253ZM4.43782 4.25317C4.43782 2.93582 5.52343 1.86067 6.86121 1.86067C8.19916 1.86067 9.28477 2.93583 9.28477 4.25317C9.28477 5.5707 8.19916 6.64586 6.86121 6.64586C5.52344 6.64586 4.43782 5.57071 4.43782 4.25317Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.3"
      />
    </svg>
  );
}

export function contentSharingIcon(fill) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.667 1.667H5.00033C4.55831 1.667 4.13437 1.84259 3.82181 2.15515C3.50925 2.46771 3.33366 2.89165 3.33366 3.33366V16.667C3.33366 17.109 3.50925 17.533 3.82181 17.8455C4.13437 18.1581 4.55831 18.3337 5.00033 18.3337H15.0003C15.4423 18.3337 15.8663 18.1581 16.1788 17.8455C16.4914 17.533 16.667 17.109 16.667 16.667V6.66699L11.667 1.667Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 1.667V6.66699H16.667"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 10.8337H6.66699"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 14.167H6.66699"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33366 7.5H7.50033H6.66699"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function reportIcon(fill) {
  return (
    <svg width="15" height="18" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.1375 20H3.38595C1.48981 20 0 18.5135 0 16.6216V3.37838C0 1.48649 1.48981 0 3.38595 0H13.1375C15.0336 0 16.5234 1.48649 16.5234 3.37838V16.6216C16.5234 18.5135 15.0336 20 13.1375 20ZM3.38595 1.35135C2.30244 1.35135 1.35438 2.2973 1.35438 3.37838V16.6216C1.35438 17.7027 2.30244 18.6486 3.38595 18.6486H13.1375C14.221 18.6486 15.169 17.7027 15.169 16.6216V3.37838C15.169 2.2973 14.221 1.35135 13.1375 1.35135H3.38595Z"
        fill={fill}
      />
      <path
        d="M11.3783 4.99997H5.00966C4.63649 4.99997 4.33398 5.30248 4.33398 5.67564C4.33398 6.04881 4.6365 6.35132 5.00966 6.35132H11.3783C11.7514 6.35132 12.0539 6.04881 12.0539 5.67564C12.0539 5.30248 11.7514 4.99997 11.3783 4.99997Z"
        fill={fill}
      />
      <path
        d="M11.3783 9.05396H5.00966C4.63649 9.05396 4.33398 9.35647 4.33398 9.72963C4.33398 10.1028 4.6365 10.4053 5.00966 10.4053H11.3783C11.7514 10.4053 12.0539 10.1028 12.0539 9.72963C12.0539 9.35647 11.7514 9.05396 11.3783 9.05396Z"
        fill={fill}
      />
      <path
        d="M11.3783 13.2431H5.00966C4.63649 13.2431 4.33398 13.5456 4.33398 13.9188C4.33398 14.292 4.6365 14.5945 5.00966 14.5945H11.3783C11.7514 14.5945 12.0539 14.292 12.0539 13.9188C12.0539 13.5456 11.7514 13.2431 11.3783 13.2431Z"
        fill={fill}
      />
    </svg>
  );
}

export const ShareIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
    transform="rotate(270)"
    width="15"
    height="15"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H5" />
  </svg>
);

export function actionIcon(fill) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4666 2.08909L16.4666 2.08908C18.3715 1.30022 20.3831 0.9 22.4449 0.9C22.7375 0.9 22.9746 1.13712 22.9746 1.42969C22.9746 3.49155 22.5746 5.5031 21.7854 7.4082C21.2871 8.61122 20.6484 9.7343 19.8785 10.7662C19.8787 10.7743 19.8787 10.7827 19.8785 10.7913C19.8785 10.7913 19.8785 10.7914 19.8785 10.7914L19.86 10.7909C19.8588 10.7925 19.8575 10.7941 19.8563 10.7958L19.8495 10.7906L19.7785 10.7886M16.4666 2.08909L3.82657 9.38074C3.65872 9.54858 3.65872 9.82066 3.82657 9.98851L5.73062 11.8924L7.04502 13.2068M16.4666 2.08909C15.2634 2.58757 14.1404 3.22618 13.1085 3.99603M16.4666 2.08909L4.62111 18.6569M19.7785 10.7886L19.8493 10.7905L19.7763 10.7358M19.7785 10.7886C19.779 10.7707 19.778 10.753 19.7763 10.7358M19.7785 10.7886C19.709 13.4213 18.6452 15.8967 16.7831 17.759M19.7763 10.7358C20.5511 9.7025 21.1931 8.57675 21.693 7.36994C22.4771 5.47696 22.8746 3.47842 22.8746 1.42969C22.8746 1.19235 22.6823 1 22.4449 1C20.3962 1 18.3976 1.39763 16.5048 2.18147C15.298 2.68148 14.1724 3.32333 13.1392 4.09794M19.7763 10.7358L13.0861 4.09609M16.7831 17.759L14.4939 20.048C14.41 20.132 14.3 20.1739 14.1901 20.1739C14.0801 20.1739 13.97 20.132 13.8861 20.048M16.7831 17.759L16.8538 17.8297L14.5646 20.1188C14.4612 20.2222 14.3255 20.2739 14.1901 20.2739C14.0547 20.2739 13.9188 20.2222 13.8154 20.1188L13.8861 20.048M16.7831 17.759L10.6641 16.9674M13.8861 20.048L11.9822 18.144L10.6678 16.8298M13.8861 20.048L13.8154 20.1187L11.9115 18.2147L10.6641 16.9674M10.6678 16.8298C9.34284 18.0304 7.66169 18.8181 5.88772 19.0609L5.20408 19.1544M10.6678 16.8298L10.5971 16.9005L10.6641 16.9674M10.6678 16.8298L10.735 16.9039C10.7114 16.9252 10.6878 16.9464 10.6641 16.9674M5.20408 19.1544C5.18461 19.1571 5.16514 19.1585 5.14584 19.1585C5.03271 19.1585 4.92328 19.1138 4.84204 19.0326C4.74704 18.9376 4.70189 18.8036 4.72018 18.6705M5.20408 19.1544L5.21775 19.2535C5.19381 19.2568 5.16978 19.2585 5.14584 19.2585C5.00638 19.2585 4.87145 19.2034 4.77133 19.1033C4.65425 18.9862 4.59856 18.8211 4.62111 18.657M5.20408 19.1544L4.62111 18.657M4.72018 18.6705L4.81384 17.9869C5.05671 16.2129 5.84442 14.5318 7.04502 13.2068M4.72018 18.6705L4.62111 18.657M4.72018 18.6705L4.62111 18.6569M7.04502 13.2068L6.97092 13.1396C6.9496 13.1632 6.92842 13.1868 6.90736 13.2105M7.04502 13.2068L6.97431 13.2775L6.90736 13.2105M6.90736 13.2105C5.72907 14.5392 4.95608 16.2108 4.71476 17.9733L4.62111 18.6569M6.90736 13.2105L5.65991 11.9631L3.75586 10.0592L3.75586 10.0592C3.54896 9.85232 3.54896 9.51692 3.75586 9.31002L6.04511 7.02077C6.04511 7.02077 6.04511 7.02077 6.04511 7.02077C7.92531 5.1404 10.4252 4.06629 13.0835 3.99613L13.084 4.01434C13.0886 4.01091 13.0931 4.00748 13.0977 4.00406C13.1013 4.00138 13.1049 3.99871 13.1085 3.99603M4.62111 18.6569L4.62111 18.657M13.1085 3.99603C13.122 3.99631 13.1356 3.9971 13.149 3.99842L13.1392 4.09794M13.1085 3.99603C13.1049 3.99596 13.1013 3.99593 13.0977 3.99593C13.0942 3.99593 13.0882 3.99591 13.0818 3.99619L13.0826 4.01535C13.0815 4.01621 13.0803 4.01707 13.0792 4.01793L13.083 4.02295L13.0861 4.09609M13.1392 4.09794L13.0977 4.04264L13.0843 4.02468L13.0861 4.09609M13.1392 4.09794C13.1256 4.0966 13.1117 4.09593 13.0977 4.09593C13.0939 4.09593 13.09 4.09593 13.0861 4.09609M6.03442 10.8394L4.87956 9.68453L6.79413 7.7698C6.79414 7.7698 6.79414 7.76979 6.79414 7.76979C8.13898 6.42512 9.8363 5.53991 11.6774 5.20365C11.5834 5.29298 11.4903 5.38359 11.3983 5.47554L11.3982 5.47557L6.03442 10.8394ZM18.6708 12.1973C18.3347 14.0384 17.4495 15.7357 16.1046 17.0805L16.1754 17.1512L16.1046 17.0805L14.1901 18.9952L13.035 17.8402L14.1146 16.7606C14.3213 16.5539 14.3213 16.2185 14.1146 16.0117L14.1146 16.0116C13.9077 15.8047 13.5723 15.8047 13.3654 16.0116L12.286 17.091L11.05 15.8552L6.78345 11.5886L12.1474 6.22477L12.0767 6.15406L12.1474 6.22477C14.7706 3.60142 18.2176 2.10242 21.9054 1.96901C21.7722 5.65699 20.2732 9.10399 17.6498 11.7272L17.7206 11.7979L17.6498 11.7272L15.9326 13.4444C15.7257 13.6513 15.7257 13.9867 15.9326 14.1936L15.9326 14.1936C16.1395 14.4003 16.4747 14.4003 16.6816 14.1936L16.6816 14.1936L18.3989 12.4764C18.4909 12.3844 18.5815 12.2913 18.6708 12.1973ZM5.7653 18.1093C5.9765 16.5779 6.64276 15.1236 7.65759 13.9609L9.91383 16.217C8.75095 17.2319 7.29664 17.8981 5.7653 18.1093Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M14.6256 14.7515C14.5267 14.8503 14.4708 14.9862 14.4708 15.126C14.4708 15.2652 14.5266 15.4017 14.6257 15.5006L14.6258 15.5006C14.7246 15.5991 14.8604 15.6557 15.0005 15.6557C15.1402 15.6557 15.2759 15.599 15.3748 15.5007L15.375 15.5005C15.4736 15.4019 15.5302 15.2655 15.5302 15.126C15.5302 14.9859 15.4736 14.8501 15.375 14.7515C15.2758 14.6522 15.1395 14.5963 15.0005 14.5963C14.8607 14.5963 14.7248 14.6522 14.6256 14.7515ZM14.6256 14.7515C14.6257 14.7514 14.6257 14.7514 14.6257 14.7514L14.6963 14.8222M14.6256 14.7515C14.6256 14.7515 14.6256 14.7515 14.6256 14.7515L14.6963 14.8222M14.6963 14.8222C14.6163 14.9021 14.5708 15.0125 14.5708 15.126C14.5708 15.2389 14.6163 15.3499 14.6963 15.4298H15.3043C15.3842 15.3499 15.4302 15.2389 15.4302 15.126C15.4302 15.0125 15.3842 14.9021 15.3043 14.8222C15.2239 14.7418 15.1131 14.6963 15.0005 14.6963C14.887 14.6963 14.7766 14.7418 14.6963 14.8222Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M11.7545 10.4384L11.7545 10.4384C11.5297 10.6632 11.4062 10.9614 11.4062 11.2793C11.4062 11.597 11.5297 11.8953 11.7545 12.12L11.7545 12.12C11.9792 12.3448 12.2775 12.4684 12.5952 12.4684C12.9131 12.4684 13.2113 12.3448 13.4361 12.12C13.6607 11.8954 13.7843 11.597 13.7843 11.2793C13.7843 10.9614 13.6607 10.6632 13.4361 10.4384C13.4361 10.4384 13.4361 10.4384 13.436 10.4384M11.7545 10.4384L11.6838 10.3677C11.9272 10.1242 12.251 9.99023 12.5952 9.99023C12.9396 9.99023 13.2632 10.1242 13.5068 10.3677L13.436 10.4384M11.7545 10.4384C11.9791 10.2137 12.2774 10.0902 12.5952 10.0902C12.9131 10.0902 13.2113 10.2136 13.436 10.4384M11.7545 10.4384H13.436M12.5952 9.03086C13.1956 9.03086 13.7606 9.26478 14.1851 9.68939C14.6097 10.1138 14.8436 10.6789 14.8436 11.2793C14.8436 11.8795 14.6097 12.4445 14.1851 12.869C14.1851 12.869 14.1851 12.869 14.1851 12.869M12.5952 9.03086L11.0762 12.7983C11.4819 13.2042 12.0215 13.4277 12.5952 13.4277C13.1691 13.4277 13.7087 13.2042 14.1144 12.7983L14.1851 12.869M12.5952 9.03086C11.995 9.03086 11.43 9.26478 11.0055 9.68939M12.5952 9.03086L11.0055 12.869M14.1851 12.869C13.7606 13.2936 13.1956 13.5277 12.5952 13.5277C11.995 13.5277 11.4299 13.2936 11.0055 12.869M14.1851 12.869L11.0055 12.869M11.0055 12.869C10.5809 12.4446 10.3468 11.8795 10.3468 11.2793C10.3468 10.6789 10.5809 10.1139 11.0055 9.68942M11.0055 9.68942L11.0762 9.76012L11.0055 9.68939M11.0055 9.68942C11.0055 9.68941 11.0055 9.68941 11.0055 9.6894M11.0055 9.68942C11.0055 9.68941 11.0055 9.68941 11.0055 9.6894M11.0055 9.68939C11.0055 9.68939 11.0055 9.6894 11.0055 9.6894M11.0055 9.68939L11.0055 9.6894"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M15.3246 8.54983L15.3247 8.54986C15.7493 8.97427 16.3141 9.20839 16.9145 9.20839C17.5149 9.20839 18.08 8.97428 18.5044 8.54984C18.929 8.12524 19.163 7.56034 19.163 6.95996C19.163 6.35958 18.9291 5.79451 18.5044 5.37005C18.08 4.94544 17.5149 4.71152 16.9145 4.71152C16.3142 4.71152 15.7493 4.94546 15.3247 5.37007C14.9002 5.79451 14.6661 6.35957 14.6661 6.95996C14.6661 7.56036 14.9002 8.12524 15.3246 8.54983ZM16.0739 6.11909L16.0739 6.11907C16.2985 5.89432 16.5968 5.7709 16.9145 5.7709C17.2325 5.7709 17.5306 5.89432 17.7554 6.11909C17.9802 6.34387 18.1036 6.64204 18.1036 6.95996C18.1036 7.27772 17.9802 7.57604 17.7554 7.80063L17.7554 7.80065C17.5306 8.02545 17.2324 8.14902 16.9145 8.14902C16.5968 8.14902 16.2985 8.02544 16.0739 7.80068L16.0738 7.80063C15.8491 7.57601 15.7255 7.27769 15.7255 6.95996C15.7255 6.64207 15.8491 6.34389 16.0739 6.11909Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M11.4646 19.4106C11.6716 19.2039 11.6715 18.8684 11.4646 18.6616C11.2579 18.4549 10.9225 18.4546 10.7156 18.6616C10.7156 18.6616 10.7156 18.6616 10.7156 18.6616L7.7793 21.5977L7.7793 21.5977C7.5724 21.8046 7.5724 22.14 7.7793 22.3469L7.77937 22.347C7.88276 22.4501 8.01842 22.5019 8.15381 22.5019C8.28919 22.5019 8.42485 22.4501 8.52825 22.347L8.52832 22.3469L11.4646 19.4106ZM11.4646 19.4106L11.3939 19.3399L11.4646 19.4106L11.4646 19.4106Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M3.99912 16.0109L3.99913 16.0109C4.20602 15.804 4.20602 15.4686 3.99913 15.2617C3.79223 15.0548 3.457 15.0548 3.2501 15.2617L1.18412 17.3277C0.97715 17.5345 0.977201 17.8699 1.18408 18.0768C1.2875 18.1802 1.4232 18.2319 1.55859 18.2319C1.69399 18.2319 1.82969 18.1802 1.9331 18.0768C1.9331 18.0768 1.9331 18.0768 1.93311 18.0768L3.99912 16.0109Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M5.25492 14.7551L5.25514 14.7549C5.35376 14.6563 5.41032 14.5201 5.41032 14.3804C5.41032 14.2409 5.35377 14.1045 5.25514 14.0059L5.25514 14.0059L5.25492 14.0056C5.15601 13.9073 5.02031 13.8507 4.88063 13.8507C4.74088 13.8507 4.60482 13.9073 4.50584 14.0056L4.50584 14.0056L4.50561 14.0059C4.40698 14.1045 4.35044 14.2409 4.35044 14.3804C4.35044 14.5201 4.407 14.6563 4.50561 14.7549L4.50584 14.7551C4.60482 14.8535 4.74088 14.9101 4.88063 14.9101C5.02031 14.9101 5.15601 14.8534 5.25492 14.7551Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M7.30779 20.9937C7.51476 20.7869 7.51471 20.4515 7.30783 20.2446C7.10093 20.0377 6.7657 20.0377 6.5588 20.2446L4.60742 22.196C4.40052 22.4029 4.40052 22.7381 4.60742 22.945C4.71084 23.0484 4.84654 23.1002 4.98193 23.1002C5.11733 23.1002 5.25303 23.0484 5.35645 22.945L7.30779 20.9937ZM7.30779 20.9937L7.23712 20.9229L7.30783 20.9937L7.30779 20.9937Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function cogIcon() {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3478 8.36251H17.0497C17.0497 8.00626 16.8137 7.65003 16.6956 7.41253L17.6398 6.46251C18.2298 5.86876 18.2298 4.91877 17.6398 4.32502L16.5776 3.25628C15.9876 2.66253 15.0435 2.66253 14.4534 3.25628L13.5093 4.20626C13.1553 4.08751 12.9193 3.96878 12.5652 3.85003V2.42501C12.5652 1.59376 11.8571 1 11.1491 1H9.73292C8.90683 1 8.31677 1.71251 8.31677 2.42501V3.73127C7.96273 3.73127 7.72671 3.96876 7.37267 4.08751L6.42857 3.13752C5.83851 2.54377 4.89441 2.54377 4.30435 3.13752L3.24224 4.20626C2.65218 4.80001 2.65218 5.75 3.24224 6.34375L4.18634 7.29377C4.06832 7.65002 3.95031 7.88751 3.8323 8.24376H2.41615C1.59006 8.24376 1 8.95627 1 9.66877V11.0938C1 11.925 1.70808 12.5188 2.41615 12.5188H3.71428C3.71428 12.875 3.95031 13.2312 4.06833 13.4688L3.12422 14.4188C2.53416 15.0125 2.53416 15.9625 3.12422 16.5563L4.18634 17.625C4.7764 18.2188 5.7205 18.2188 6.31056 17.625L7.13665 16.7938C7.49068 16.9125 7.84472 17.15 8.19876 17.2688V18.575C8.19876 19.4063 8.90683 20 9.6149 20H11.0311C11.8571 20 12.4472 19.2875 12.4472 18.575V17.3875C12.8012 17.3875 13.1553 17.15 13.5093 16.9125L14.4534 17.8625C15.0435 18.4563 15.9876 18.4563 16.5776 17.8625L17.6398 16.7938C18.2298 16.2 18.2298 15.25 17.6398 14.6562L16.8137 13.825C16.9317 13.4688 17.1677 13.1125 17.2857 12.7563H18.5839C19.4099 12.7563 20 12.0438 20 11.3313V9.90625C20 9.075 19.2919 8.48127 18.5839 8.48127L18.3478 8.36251ZM13.0373 10.6188C13.0373 12.1625 11.8571 13.35 10.323 13.35C8.78882 13.35 7.6087 12.1625 7.6087 10.6188C7.6087 9.07501 8.78882 7.88752 10.323 7.88752C11.8571 7.88752 13.0373 9.07501 13.0373 10.6188Z"
        stroke="#9E9FA1"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function cultureIcon(fill) {
  return (
    <svg width="16" height="15" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0926 21C5.31751 21 0.569092 16.2622 0.569092 10.5C0.569092 4.73781 5.31751 0 11.0926 0C16.8677 0 21.6162 4.73781 21.6162 10.5C21.6162 16.2622 16.8677 21 11.0926 21ZM11.0926 1.28049C5.95919 1.28049 1.85245 5.37805 1.85245 10.5C1.85245 15.622 5.95919 19.7195 11.0926 19.7195C16.2261 19.7195 20.3328 15.622 20.3328 10.5C20.3328 5.37805 16.2261 1.28049 11.0926 1.28049Z"
        fill={fill}
      />
      <path
        d="M4.03417 11.3965H6.08754C7.11423 11.3965 7.11423 9.85989 6.08754 9.85989H4.03417C3.00749 9.85989 3.00749 11.3965 4.03417 11.3965Z"
        fill={fill}
      />
      <path
        d="M5.57425 6.14644C6.08759 6.65864 6.60093 7.17083 6.98594 7.55498C7.75596 8.32327 8.91098 7.17083 8.14096 6.40253L6.72927 4.994C5.95925 4.22571 4.80424 5.37815 5.57425 6.14644Z"
        fill={fill}
      />
      <path
        d="M10.1943 3.58531V5.63409C10.1943 6.65848 11.7344 6.65848 11.7344 5.63409V3.58531C11.7344 2.56092 10.1943 2.56092 10.1943 3.58531Z"
        fill={fill}
      />
      <path
        d="M15.3275 4.994C14.8142 5.5062 14.3008 6.01839 13.9158 6.40253C13.1458 7.17083 14.3008 8.32327 15.0708 7.55498L16.4825 6.14644C17.2525 5.37815 16.0975 4.22571 15.3275 4.994Z"
        fill={fill}
      />
      <path
        d="M18.0228 9.73172H15.9695C14.9428 9.73172 14.9428 11.2683 15.9695 11.2683H18.0228C19.0495 11.2683 19.0495 9.73172 18.0228 9.73172Z"
        fill={fill}
      />
      <path
        d="M16.6112 14.8538C16.0978 14.3416 15.5845 13.8294 15.1995 13.4453C14.4295 12.677 13.2744 13.8294 14.0445 14.5977L15.4562 16.0062C16.2262 16.7745 17.3812 15.6221 16.6112 14.8538Z"
        fill={fill}
      />
      <path
        d="M11.8625 17.4148V15.366C11.8625 14.3416 10.3225 14.3416 10.3225 15.366V17.4148C10.3225 18.4392 11.8625 18.4392 11.8625 17.4148Z"
        fill={fill}
      />
      <path
        d="M6.72927 16.0062L8.14096 14.5977C8.91098 13.8294 7.75596 12.677 6.98594 13.4453L5.57425 14.8538C4.80424 15.6221 5.95925 16.7745 6.72927 16.0062Z"
        fill={fill}
      />
    </svg>
  );
}

export function calendarIcon(fill) {
  return (
    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_158)">
        <path
          d="M3.02222 20H16.9778C18.4407 20 19.6296 18.8111 19.6296 17.3481V4.13331C19.6296 2.67035 18.4407 1.48145 16.9778 1.48145H15.9259V0.740727C15.9259 0.333315 15.5926 0 15.1851 0C14.7777 0 14.4444 0.333315 14.4444 0.740727V1.48145H5.55557V0.740727C5.55557 0.333315 5.2222 0 4.81479 0C4.40737 0 4.07406 0.333315 4.07406 0.740727V1.48145H3.02222C1.55926 1.48145 0.370361 2.67035 0.370361 4.13331V17.3481C0.370361 18.8111 1.55926 20 3.02222 20ZM1.85188 4.13331C1.85188 3.48889 2.3778 2.96297 3.02222 2.96297H4.07406V3.7037C4.07406 4.11111 4.40737 4.44442 4.81479 4.44442C5.2222 4.44442 5.55551 4.11111 5.55551 3.7037V2.96297H14.4444V3.7037C14.4444 4.11111 14.7777 4.44442 15.1851 4.44442C15.5926 4.44442 15.9259 4.11111 15.9259 3.7037V2.96297H16.9777C17.6221 2.96297 18.1481 3.48889 18.1481 4.13331V17.3481C18.1481 17.9926 17.6221 18.5185 16.9777 18.5185H3.02222C2.3778 18.5185 1.85188 17.9926 1.85188 17.3481V4.13331Z"
          fill={fill}
        />
        <path
          d="M5.74085 8.51847C6.25222 8.51847 6.66676 8.10393 6.66676 7.59256C6.66676 7.0812 6.25222 6.66666 5.74085 6.66666C5.22948 6.66666 4.81494 7.0812 4.81494 7.59256C4.81494 8.10393 5.22948 8.51847 5.74085 8.51847Z"
          fill={fill}
        />
        <path
          d="M9.81482 8.51847C10.3262 8.51847 10.7407 8.10393 10.7407 7.59256C10.7407 7.0812 10.3262 6.66666 9.81482 6.66666C9.30346 6.66666 8.88892 7.0812 8.88892 7.59256C8.88892 8.10393 9.30346 8.51847 9.81482 8.51847Z"
          fill={fill}
        />
        <path
          d="M13.8888 8.51847C14.4002 8.51847 14.8147 8.10393 14.8147 7.59256C14.8147 7.0812 14.4002 6.66666 13.8888 6.66666C13.3774 6.66666 12.9629 7.0812 12.9629 7.59256C12.9629 8.10393 13.3774 8.51847 13.8888 8.51847Z"
          fill={fill}
        />
        <path
          d="M5.74085 12.2222C6.25222 12.2222 6.66676 11.8076 6.66676 11.2963C6.66676 10.7849 6.25222 10.3704 5.74085 10.3704C5.22948 10.3704 4.81494 10.7849 4.81494 11.2963C4.81494 11.8076 5.22948 12.2222 5.74085 12.2222Z"
          fill={fill}
        />
        <path
          d="M9.81482 12.2222C10.3262 12.2222 10.7407 11.8076 10.7407 11.2963C10.7407 10.7849 10.3262 10.3704 9.81482 10.3704C9.30346 10.3704 8.88892 10.7849 8.88892 11.2963C8.88892 11.8076 9.30346 12.2222 9.81482 12.2222Z"
          fill={fill}
        />
        <path
          d="M13.8888 12.2222C14.4002 12.2222 14.8147 11.8076 14.8147 11.2963C14.8147 10.7849 14.4002 10.3704 13.8888 10.3704C13.3774 10.3704 12.9629 10.7849 12.9629 11.2963C12.9629 11.8076 13.3774 12.2222 13.8888 12.2222Z"
          fill={fill}
        />
        <path
          d="M5.74085 15.9259C6.25222 15.9259 6.66676 15.5113 6.66676 15C6.66676 14.4886 6.25222 14.0741 5.74085 14.0741C5.22948 14.0741 4.81494 14.4886 4.81494 15C4.81494 15.5113 5.22948 15.9259 5.74085 15.9259Z"
          fill={fill}
        />
        <path
          d="M9.81482 15.9259C10.3262 15.9259 10.7407 15.5113 10.7407 15C10.7407 14.4886 10.3262 14.0741 9.81482 14.0741C9.30346 14.0741 8.88892 14.4886 8.88892 15C8.88892 15.5113 9.30346 15.9259 9.81482 15.9259Z"
          fill={fill}
        />
        <path
          d="M13.8888 15.9259C14.4002 15.9259 14.8147 15.5113 14.8147 15C14.8147 14.4886 14.4002 14.0741 13.8888 14.0741C13.3774 14.0741 12.9629 14.4886 12.9629 15C12.9629 15.5113 13.3774 15.9259 13.8888 15.9259Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_158">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function dataScienceIcon(fill) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        preserveAspectRatio="xMinYMid"
        viewBox="0 0 25 25"
      >
        <path
          fill="#b7b7b7"
          d="M23 3.4C23 1.7 18.4.2 12.7.2S2.2 1.8 2.2 3.5c0 .2.1.5.2.6l-.5-.5v18h.4C8.4 11.3 22.7 4.5 22.7 4.5c-.2.1-.4.1-.5.2.4-.4.8-.9.8-1.3z"
          className="colorA0CEC7 svgShape"
        />
        <path
          fill={fill}
          d="M23.4 3.6c.1-2.1-5-3.6-10.9-3.6S1.6 1.4 1.6 3.6v18s0-2 0 0S6.8 25 12.5 25s10.9-1.3 10.9-3.4v-18zM12.5.6c6.1 0 10.2 1.5 10.2 2.9 0 1.5-4.1 2.9-10.2 2.9S2.3 5 2.3 3.6s4.1-3 10.2-3zm10.2 21c-.3 1.4-4.4 2.7-10.2 2.7s-9.9-1.4-10.2-2.7v-5.4c1.2 1.5 5.2 2.5 10.2 2.5 4.9 0 9-1 10.2-2.4v5.3zm0-6.1c-.4 1.4-4.4 2.7-10.2 2.7s-9.9-1.4-10.2-2.7v.1-5C3.5 12.1 7.5 13 12.5 13c4.9 0 9-1 10.2-2.4v4.9zm0-5.7c-.4 1.4-4.4 2.7-10.2 2.7S2.6 11.1 2.3 9.8v.2-5.4c1.2 1.3 5.3 2.5 10.2 2.5s9-1 10.2-2.4v5.1z"
          className="color222 svgShape"
        />
        <circle
          cx="20.1"
          cy="8.7"
          r=".9"
          fill="none"
          stroke={fill}
          strokeMiterlimit="10"
          strokeWidth=".497"
          className="colorStroke222 svgStroke"
        />
        <circle
          cx="20.1"
          cy="14.7"
          r=".9"
          fill="none"
          stroke={fill}
          strokeMiterlimit="10"
          strokeWidth=".497"
          className="colorStroke222 svgStroke"
        />
        <circle
          cx="20.1"
          cy="20.7"
          r=".9"
          fill="none"
          stroke={fill}
          strokeMiterlimit="10"
          strokeWidth=".497"
          className="colorStroke222 svgStroke"
        />
      </svg>
    </svg>
  );
}

export function groupIcon(fill) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 576 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M264.5 5.20002C279.4 -1.69998 296.6 -1.69998 311.5 5.20002L530.1 106.2C538.6 110.1 544 118.6 544 128C544 137.4 538.6 145.9 530.1 149.8L311.5 250.8C296.6 257.7 279.4 257.7 264.5 250.8L45.9 149.8C37.4 145.8 32 137.3 32 128C32 118.7 37.4 110.1 45.9 106.2L264.5 5.20002ZM476.9 209.6L530.1 234.2C538.6 238.1 544 246.6 544 256C544 265.4 538.6 273.9 530.1 277.8L311.5 378.8C296.6 385.7 279.4 385.7 264.5 378.8L45.9 277.8C37.4 273.8 32 265.3 32 256C32 246.7 37.4 238.1 45.9 234.2L99.1 209.6L251.1 279.8C262.67 285.136 275.259 287.9 288 287.9C300.741 287.9 313.33 285.136 324.9 279.8L476.9 209.6ZM324.9 407.8L476.9 337.6L530.1 362.2C538.6 366.1 544 374.6 544 384C544 393.4 538.6 401.9 530.1 405.8L311.5 506.8C296.6 513.7 279.4 513.7 264.5 506.8L45.9 405.8C37.4 401.8 32 393.3 32 384C32 374.7 37.4 366.1 45.9 362.2L99.1 337.6L251.1 407.8C262.67 413.136 275.259 415.9 288 415.9C300.741 415.9 313.33 413.136 324.9 407.8Z"
        fill={fill}
      />
    </svg>
  );
}

// Single-member icon (Feather/Lucide-style outline) used for the Members nav item
export function MemberIcon(fill) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 17v-1a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="10"
        cy="7"
        r="3"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export function recommendationIcon(fill) {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 8V16C13 16.7956 12.6839 17.5587 12.1213 18.1213C11.5587 18.6839 10.7956 19 10 19H7.83C7.59409 19.6675 7.1298 20.2301 6.51919 20.5884C5.90858 20.9466 5.19098 21.0775 4.49321 20.9578C3.79545 20.8381 3.16246 20.4756 2.70613 19.9344C2.2498 19.3931 1.99951 18.708 1.99951 18C1.99951 17.292 2.2498 16.6069 2.70613 16.0656C3.16246 15.5244 3.79545 15.1619 4.49321 15.0422C5.19098 14.9225 5.90858 15.0534 6.51919 15.4116C7.1298 15.7699 7.59409 16.3325 7.83 17H10C10.2652 17 10.5196 16.8946 10.7071 16.7071C10.8946 16.5196 11 16.2652 11 16V8C11 7.20435 11.3161 6.44129 11.8787 5.87868C12.4413 5.31607 13.2044 5 14 5H17V2L22 6L17 10V7H14C13.7348 7 13.4804 7.10536 13.2929 7.29289C13.1054 7.48043 13 7.73478 13 8Z"
        fill={fill}
      />
    </svg>
  );
}

export function outcomesIcon(fill) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M176 0H16C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16V176C0 180.243 1.68571 184.313 4.68629 187.314C7.68687 190.314 11.7565 192 16 192H176C180.243 192 184.313 190.314 187.314 187.314C190.314 184.313 192 180.243 192 176V16C192 11.7565 190.314 7.68687 187.314 4.68629C184.313 1.68571 180.243 0 176 0ZM176 176H16V16H176V176ZM58.34 133.66C57.5962 132.917 57.0061 132.035 56.6035 131.064C56.2009 130.092 55.9937 129.051 55.9937 128C55.9937 126.949 56.2009 125.908 56.6035 124.936C57.0061 123.965 57.5962 123.083 58.34 122.34L108.69 72H80C77.8783 72 75.8434 71.1571 74.3431 69.6569C72.8429 68.1566 72 66.1217 72 64C72 61.8783 72.8429 59.8434 74.3431 58.3431C75.8434 56.8429 77.8783 56 80 56H128C130.122 56 132.157 56.8429 133.657 58.3431C135.157 59.8434 136 61.8783 136 64V112C136 114.122 135.157 116.157 133.657 117.657C132.157 119.157 130.122 120 128 120C125.878 120 123.843 119.157 122.343 117.657C120.843 116.157 120 114.122 120 112V83.31L69.66 133.66C68.917 134.404 68.0347 134.994 67.0635 135.396C66.0923 135.799 65.0513 136.006 64 136.006C62.9487 136.006 61.9077 135.799 60.9365 135.396C59.9653 134.994 59.083 134.404 58.34 133.66Z"
        fill={fill}
      />
    </svg>
  );
}

export function copilotIcon(fill) {
  return <CopilotIcon />;
}

export function dashboardIcon(fill) {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5789 3C20.3638 3 21 3.63623 21 4.42105L21 19.5789C21 20.3638 20.3638 21 19.5789 21L4.42105 21C3.63623 21 3 20.3638 3 19.5789L3 4.42105C3 3.63623 3.63622 3 4.42105 3L19.5789 3ZM20.0526 4.42105C20.0526 4.15944 19.8406 3.94737 19.5789 3.94737L4.42105 3.94737C4.15944 3.94737 3.94737 4.15944 3.94737 4.42105L3.94737 19.5789C3.94737 19.8406 4.15944 20.0526 4.42105 20.0526L19.5789 20.0526C19.8406 20.0526 20.0526 19.8406 20.0526 19.5789L20.0526 4.42105Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7.5C3 7.22386 3.21208 7 3.47368 7H20.5263C20.7879 7 21 7.22386 21 7.5C21 7.77614 20.7879 8 20.5263 8H3.47368C3.21208 8 3 7.77614 3 7.5Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 7C9.77614 7 10 7.22386 10 7.5V20.5C10 20.7761 9.77614 21 9.5 21C9.22386 21 9 20.7761 9 20.5V7.5C9 7.22386 9.22386 7 9.5 7Z"
        fill={fill}
      />
    </svg>
  );
}

export function FeatureToggleIcon(fill) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* First toggle switch */}
      <rect x="4" y="6" width="16" height="4" rx="2" fill={fill} opacity="0.3" />
      <circle cx="16" cy="8" r="2" fill={fill} />

      {/* Second toggle switch */}
      <rect x="4" y="14" width="16" height="4" rx="2" fill={fill} opacity="0.3" />
      <circle cx="8" cy="16" r="2" fill={fill} />
    </svg>
  );
}

export function FileIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2H6Z"
        fill="grey"
        opacity="0.15"
      />
      <path d="M14 2V8H20" fill="white" />
    </svg>
  );
}

export function glossaryIcon(fill) {
  return (
    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 4.5C4 3.67157 4.67157 3 5.5 3H14.5C15.3284 3 16 3.67157 16 4.5V15.5C16 16.3284 15.3284 17 14.5 17H5.5C4.67157 17 4 16.3284 4 15.5V4.5Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 7H13"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10H13"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 13H10"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

